shadow$provide[437] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `vec3 getRootPosition(vec4 position, in vec4 stpqIn, out vec4 stpqOut) {
  stpqOut = stpqIn; // avoid inout confusion
  return position.xyz;
}`;

};